import './current-weather.styles.scss';

const CurrentWeather = ({ weatherData }) => {
  return (
    <div className='current-weather'>
      <div className='location'>
        <p className='city'>{weatherData.city.name}, </p>
        <p className='country'>{weatherData.city.country}</p>
      </div>
      <img
        className='weather-icon'
        src={`https://www.linkpicture.com/q/${weatherData.list[0].weather[0].icon}.svg`}
        alt='weather icon'
      />
      <p className='current-temp'>
        {Math.round(weatherData.list[0].main.temp)}&deg;
      </p>
      <div className='min-max-temp'>
        <p className='min-temp'>
          {Math.round(weatherData.list[0].main.temp_min)}&deg;
        </p>
        <p className='max-temp'>
          {Math.round(weatherData.list[0].main.temp_max)}&deg;
        </p>
      </div>

      <p className='description'>
        {weatherData.list[0].weather[0].description.toUpperCase()}
      </p>
    </div>
  );
};

export default CurrentWeather;
